var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.4V3.59998H9.27406C10.1122 3.59998 10.8844 3.85823 11.5906 4.37473C12.2969 4.89135 12.65 5.6081 12.65 6.52498C12.65 7.16248 12.5094 7.65935 12.2281 8.0156C11.9469 8.37185 11.6812 8.63148 11.4312 8.79448C11.7562 8.94398 12.1062 9.21248 12.4812 9.59998C12.8562 9.98748 13.0437 10.5562 13.0437 11.3062C13.0437 12.4437 12.6248 13.2437 11.7869 13.7062C10.9491 14.1687 10.1628 14.4 9.428 14.4H5ZM7.38125 12.1875H9.344C9.948 12.1875 10.3125 12.0344 10.4375 11.7281C10.5625 11.4219 10.625 11.2 10.625 11.0625C10.625 10.925 10.5594 10.7031 10.4281 10.3969C10.2969 10.0906 9.9125 9.93748 9.275 9.93748H7.38125V12.1875ZM7.38125 7.83748H9.125C9.5375 7.83748 9.84062 7.7281 10.0344 7.50935C10.2281 7.2906 10.325 7.05623 10.325 6.80623C10.325 6.50623 10.2181 6.26248 10.0042 6.07498C9.79031 5.88748 9.51356 5.79373 9.17394 5.79373H7.38125V7.83748Z",
    fill: "#848B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.f6a3dd386dee1c863e755a6b59575191.svg";
export { ForwardRef as ReactComponent };